module.exports = require('./helpers/bundle-url').getBundleURL('5cKF3') + "logo.7718c6df.svg";